import type { IAppConfig } from '@/typescript/interfaces/IAppConfig';

export default function mockConfig(): IAppConfig {
    return {
        lang: 'fr_FR',
        is_mobile: false,
        token: import.meta.env.VITE_API_TOKEN,
        show_aspect_selector: true,
    };
}
